
























import {Vue, Component, Prop} from 'vue-property-decorator'
import CommentIcon from '../../../../assets/svg/notification-comment.svg';
import {Notification as NotificationModel} from "@api/models/notifications/Notification";
import {UserProfile} from "@api/models/UserProfile";
import UserIcon from "@share/common/UserIcon.vue";
import {EventBus} from "@common/EventBus";
import { DeepLink } from '@common/deepLink/DeepLink';
import { DeepLinkTypes } from '@common/deepLink/types';
import { NotificationLinkHelper, DeepLinkOpenParams } from '@share/notifications/helpers/NotificationLinkHelper';
import { unknowDeepLink } from '@common/deepLink/parsers';
import { getBackend } from '@service/router/getters';

@Component({
    components: { CommentIcon, UserIcon }
})
export default class NotificationComment extends Vue {
    @Prop() notification: NotificationModel;
    @Prop() author: UserProfile;

    get isRead(): boolean {
        return this.notification.isRead;
    }

    get currentLocale(): string {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "ru";
    }

    async openLink() {
        if ([process.env.VUE_APP_AGENDA_SCHEMA, process.env.VUE_APP_EVENTS_SCHEMA].includes(this.notification.data?.schemaId)) {

            let link = null;
            const linkHelper = new NotificationLinkHelper(this.$store, this.$repositories);
            const params: DeepLinkOpenParams = {
                source: "",
                backend: getBackend(this.$route.params.backend) as string,
                router: this.$router,
                route: this.$route
            };

            if(this.notification.data?.schemaId === process.env.VUE_APP_AGENDA_SCHEMA) {
                //for session
                link = new DeepLink({
                    type: DeepLinkTypes.session,
                    data: {
                        id: this.notification.data?.objectId ?? null,
                        schemaId: this.notification.data?.schemaId
                    }
                });

            }

            if(this.notification.data?.schemaId === process.env.VUE_APP_EVENTS_SCHEMA) {
                //for event
                link = new DeepLink({
                    type: DeepLinkTypes.event,
                    data: {
                        id: this.notification.data?.objectId ?? null,
                    }
                });
            }

            params.source = link ?? unknowDeepLink();
            await linkHelper.openDeepLink(params);
            EventBus.$emit('notification-opened');
        }
    }
}
